import {
  IUrlDataConnectionContext,
  UrlDataConnectionContext,
} from "@via/context/url-data-connection-context.tsx";
import { useContext } from "react";

export function useUrlDataConnection(): IUrlDataConnectionContext {
  return useContext(UrlDataConnectionContext);
}
